<div class="pd-page">

  <!-- ══ HERO SECTION ══════════════════════════════════════════════════ -->
  <div class="pd-hero">

    <nav class="pd-bc">
      <button (click)="goToHome()" class="pd-bc-btn">
        <i class="fa-solid fa-house"></i> Dashboard
      </button>
      <i class="fa-solid fa-chevron-right pd-bc-sep"></i>
      <span>HM Priority Projects</span>
    </nav>

    <div class="pd-hero-body">
      <h1 class="pd-title">
        <span class="pd-title-star"><i class="fa-solid fa-star"></i></span>
        HM Priority Projects
      </h1>
      <p class="pd-sub">
        High-visibility projects under Hon'ble Minister's direct monitoring &amp; commitment
      </p>
    </div>

    <!-- Stats strip — always visible on mobile -->
    <div class="pd-stats-strip">
      <div class="pd-stat">
        <span class="pd-stat-val">{{ priStats().total }}</span>
        <span class="pd-stat-lbl">Projects</span>
      </div>
      <div class="pd-stat-div"></div>
      <div class="pd-stat">
        <span class="pd-stat-val">{{ fmt(priStats().totalCost) }}</span>
        <span class="pd-stat-lbl">Total Cost</span>
      </div>
      <div class="pd-stat-div"></div>
      <div class="pd-stat">
        <span class="pd-stat-val">{{ fmt(priStats().totalSpent) }}</span>
        <span class="pd-stat-lbl">Total Spent</span>
      </div>
      <div class="pd-stat-div"></div>
      <div class="pd-stat">
        <span class="pd-stat-val">{{ priStats().pctSpent }}%</span>
        <span class="pd-stat-lbl">% Spent</span>
      </div>
    </div>

  </div><!-- /pd-hero -->


  <!-- ══ TOOLBAR ═══════════════════════════════════════════════════════ -->
  <div class="pd-toolbar-wrap">
    <div class="pd-toolbar">

      <!-- Row 1: Search + filter toggle (mobile) -->
      <div class="pd-toolbar-top">
        <div class="pd-search-box">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input
            class="pd-search-inp"
            type="text"
            placeholder="Search project, dept, location…"
            [value]="searchQuery()"
            (input)="searchQuery.set($any($event.target).value); currentPage.set(1)" />
        </div>
        <button class="pd-filter-toggle" (click)="toggleFilterPanel()"
          [class.pd-filter-toggle--active]="showFilterPanel()">
          <i class="fa-solid fa-sliders"></i>
          <span>Filter</span>
          @if (hasActiveFilters()) { <span class="pd-filter-dot"></span> }
        </button>
      </div>

      <!-- Filter panel (collapsible on mobile, always-on on desktop) -->
      <div class="pd-filter-panel" [class.pd-filter-panel--hidden]="!showFilterPanel()">
        <select class="pd-sel" [value]="filterStatus()"
          (change)="filterStatus.set($any($event.target).value); currentPage.set(1)">
          <option value="">All Status</option>
          <option value="Planned">Planned</option>
          <option value="In Progress">In Progress</option>
          <option value="Completed">Completed</option>
          <option value="Stuck">Stuck</option>
        </select>

        <select class="pd-sel" [value]="filterScheme()"
          (change)="filterScheme.set($any($event.target).value); currentPage.set(1)">
          <option value="">All Schemes</option>
          @for (s of availableSchemes(); track s) {
            <option [value]="s">{{ s }}</option>
          }
        </select>

        <select class="pd-sel" [value]="filterBlock()"
          (change)="filterBlock.set($any($event.target).value); currentPage.set(1)">
          <option value="">All Blocks</option>
          @for (b of availableBlocks(); track b) {
            <option [value]="b">{{ b }}</option>
          }
        </select>

        <select class="pd-sel" [value]="filterGP()"
          (change)="filterGP.set($any($event.target).value); currentPage.set(1)">
          <option value="">All GPs</option>
          @for (g of availableGPs(); track g) {
            <option [value]="g">{{ g }}</option>
          }
        </select>

        @if (hasActiveFilters()) {
          <button class="pd-btn-clear" (click)="clearFilters()">
            <i class="fa-solid fa-xmark"></i> Clear
          </button>
        }
      </div>

      <!-- Row 2: Export + View toggle -->
      <div class="pd-toolbar-controls">
        <button class="pd-btn-export" (click)="exportToExcel()">
          <i class="fa-solid fa-file-excel"></i> Export
        </button>
        <div class="pd-view-toggle">
          <button [class.pd-vt-active]="!cardView()" (click)="cardView.set(false); currentPage.set(1)">
            <i class="fa-solid fa-table-list"></i> Table
          </button>
          <button [class.pd-vt-active]="cardView()" (click)="cardView.set(true); currentPage.set(1)">
            <i class="fa-solid fa-grip"></i> Cards
          </button>
        </div>
      </div>

    </div>
  </div><!-- /pd-toolbar-wrap -->


  <!-- ══ RESULTS COUNT ═════════════════════════════════════════════════ -->
  <div class="pd-results-bar">
    <span>
      Showing <strong>{{ pageStart() }}–{{ pageEnd() }}</strong>
      of <strong>{{ filteredProjects().length }}</strong> projects
      @if (hasActiveFilters()) { <span class="pd-filt-chip">filtered</span> }
    </span>
  </div>


  <!-- ══ EMPTY STATE ════════════════════════════════════════════════════ -->
  @if (filteredProjects().length === 0) {
    <div class="pd-empty">
      <i class="fa-solid fa-folder-open"></i>
      <p>No HM priority projects found</p>
      @if (hasActiveFilters()) {
        <button class="pd-btn-clear" (click)="clearFilters()">Clear Filters</button>
      }
    </div>
  }


  <!-- ══ CARD GRID ══════════════════════════════════════════════════════ -->
  @if (cardView() && filteredProjects().length > 0) {
    <div class="pd-grid">
      @for (p of paginatedProjects(); track p.id; let i = $index) {

        <div class="pd-card" (click)="openProjectDetails(p.id)">

          <!-- Card header: dept icon + name + number badge -->
          <div class="pd-card-hdr">
            <div class="pd-dept-ico" [style.background]="getDeptColor(p.dept)">
              {{ getDeptAbbr(p.dept) }}
            </div>
            <div class="pd-card-title-block">
              <div class="pd-card-name">{{ p.name }}</div>
              <div class="pd-card-dept-row">
                <span class="pd-card-dept-name">{{ p.dept }}</span>
                @if (p.hmPriority) {
                  <span class="pd-chip pd-chip-hm"><i class="fa-solid fa-star"></i> HM</span>
                }
              </div>
            </div>
            <div class="pd-card-num">{{ pageStart() + i }}</div>
          </div>

          <!-- Data rows -->
          <div class="pd-card-rows">
            <div class="pd-data-row">
              <span class="pd-row-lbl"><i class="fa-solid fa-location-dot"></i> Location</span>
              <span class="pd-row-val">{{ p.loc || '—' }}</span>
            </div>
            <div class="pd-data-row">
              <span class="pd-row-lbl"><i class="fa-solid fa-indian-rupee-sign"></i> Total Cost</span>
              <span class="pd-row-val">{{ fmt(p.cost) }}</span>
            </div>
            <div class="pd-data-row">
              <span class="pd-row-lbl"><i class="fa-solid fa-chart-pie"></i> Total Spent</span>
              <span class="pd-row-val">{{ fmt(p.spent) }}</span>
            </div>
          </div>

          <!-- Progress -->
          <div class="pd-card-progress">
            <div class="pd-prog-header">
              <span class="pd-prog-label"><i class="fa-solid fa-gauge"></i> Progress</span>
              <span class="pd-prog-pct" [style.color]="progressColor(p.physical)">{{ p.physical }}%</span>
            </div>
            <div class="pd-prog-track">
              <div class="pd-prog-fill"
                [style.width.%]="p.physical"
                [style.background]="progressColor(p.physical)">
              </div>
            </div>
          </div>

          <!-- Footer: chips + button -->
          <div class="pd-card-foot">
            <div class="pd-foot-chips">
              <span [class]="'pd-chip ' + statusClass(p.status)">{{ p.status }}</span>
              @if (p.recurringIntervention) {
                <span class="pd-chip pd-chip-rec"><i class="fa-solid fa-rotate"></i> Recurring</span>
              }
              @if (p.isDelayed) {
                <span class="pd-chip pd-chip-del"><i class="fa-solid fa-triangle-exclamation"></i> Delayed</span>
              }
              @if (p.visibility && !p.hmPriority) {
                <span class="pd-chip pd-chip-vis">{{ p.visibility }}</span>
              }
            </div>
            <button class="pd-check-btn"
              (click)="openProjectDetails(p.id); $event.stopPropagation()">
              Check Status <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>

        </div>

      }
    </div>
  }


  <!-- ══ TABLE VIEW ═════════════════════════════════════════════════════ -->
  @if (!cardView() && filteredProjects().length > 0) {
    <div class="pd-tbl-wrap">
      <table class="pd-table">
        <thead>
          <tr>
            <th class="pd-th-num">#</th>
            <th class="pd-th-name">Project Name</th>
            <th class="pd-th-cost">Cost</th>
            <th class="pd-th-prog">Progress</th>
            <th class="pd-th-status">Status</th>
          </tr>
        </thead>
        <tbody>
          @for (p of paginatedProjects(); track p.id; let i = $index) {
            <tr (click)="openProjectDetails(p.id)">
              <td class="pd-td-c pd-td-num">{{ pageStart() + i }}</td>
              <td class="pd-td-name-cell">
                <div class="pd-tbl-name-wrap">
                  <div class="pd-tbl-dept-ico" [style.background]="getDeptColor(p.dept)">
                    {{ getDeptAbbr(p.dept) }}
                  </div>
                  <div class="pd-tbl-name-block">
                    <div class="pd-tbl-pname">{{ p.name }}</div>
                    <div class="pd-tbl-dept-badges">
                      @if (p.hmPriority) {
                        <span class="pd-chip pd-chip-hm" style="font-size:8px;padding:1px 5px">HM</span>
                      }
                      <span class="pd-tbl-dept-lbl">{{ p.dept }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="pd-td-cost">{{ fmt(p.cost) }}</td>
              <td class="pd-td-prog-cell">
                <div class="pd-tbl-prog">
                  <div class="pd-prog-track">
                    <div class="pd-prog-fill"
                      [style.width.%]="p.physical"
                      [style.background]="progressColor(p.physical)">
                    </div>
                  </div>
                  <span class="pd-tbl-pct" [style.color]="progressColor(p.physical)">
                    {{ p.physical }}%
                  </span>
                </div>
              </td>
              <td class="pd-td-status">
                <span [class]="'pd-chip ' + statusClass(p.status)">{{ p.status }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }


  <!-- ══ PAGINATION ═════════════════════════════════════════════════════ -->
  @if (filteredProjects().length > pageSize) {
    <div class="pd-pagination">
      <span class="pd-pag-info">
        Showing {{ pageStart() }} to {{ pageEnd() }} of {{ filteredProjects().length }} projects
      </span>
      <div class="pd-pag-btns">
        <button class="pd-pag-nav"
          [disabled]="currentPage() === 1"
          (click)="goToPage(currentPage() - 1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        @for (pg of visiblePageNumbers(); track $index) {
          @if (pg === -1) {
            <span class="pd-pag-ellipsis">…</span>
          } @else {
            <button
              [class.pd-pag-act]="currentPage() === pg"
              (click)="goToPage(pg)">
              {{ pg }}
            </button>
          }
        }
        <button class="pd-pag-nav"
          [disabled]="currentPage() === totalPages()"
          (click)="goToPage(currentPage() + 1)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
    </div>
  }

</div>
